import { Country, blankCountry, copyCountry } from '.';

export type AddressTypeCode = 'Celebratory-Item' | 'Trophy' | 'Contact';

export interface WinnerAddress {
  questionnaireId: number;
  addressTypeCode: AddressTypeCode;
  address1: string;
  address2: string;
  city: string;
  stateProvince: string;
  postalCode: string;
  country: Country;
  phoneNumber: string;
  attentionTo: string;
}

export function blankWinnerAddress(questionnaireId: number, addressTypeCode: AddressTypeCode): WinnerAddress {
  return {
    questionnaireId,
    addressTypeCode,
    address1: '',
    address2: '',
    city: '',
    stateProvince: '',
    postalCode: '',
    country: blankCountry(),
    phoneNumber: '',
    attentionTo: '',
  };
}

export function copyWinnerAddress(winnerAddress: WinnerAddress): WinnerAddress {
  return {
    questionnaireId: winnerAddress.questionnaireId,
    addressTypeCode: winnerAddress.addressTypeCode,
    address1: winnerAddress.address1,
    address2: winnerAddress.address2,
    city: winnerAddress.city,
    stateProvince: winnerAddress.stateProvince,
    postalCode: winnerAddress.postalCode,
    country: winnerAddress.country ? copyCountry(winnerAddress.country) : blankCountry(),
    phoneNumber: winnerAddress.phoneNumber,
    attentionTo: winnerAddress.attentionTo,
  };
}
